import { useParams } from "react-router-dom";
import { useCompanyAccessMode } from "features/company-select/group-visitor";
import CompanyAbout from "./company-about-container";
import VisitorCompanyAbout from "./visitor-company-about";

/** Members get the full company page; a group visitor gets the public one. */
export default function CompanyAboutRoute() {
  const { companyId } = useParams();
  const accessMode = useCompanyAccessMode(companyId);
  return accessMode === "visitor" ? <VisitorCompanyAbout /> : <CompanyAbout />;
}
